import { render, staticRenderFns } from "./attack.vue?vue&type=template&id=1c603d8c&scoped=true"
import script from "./attack.vue?vue&type=script&lang=js"
export * from "./attack.vue?vue&type=script&lang=js"
import style0 from "./attack.vue?vue&type=style&index=0&id=1c603d8c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c603d8c",
  null
  
)

export default component.exports